import { Grid } from '@mui/material';
import React from 'react';
import FingoSteps from './FingoSteps';
import Hero from './Hero';
import OurSolutions from './OurSolutions';
import Statistics from './Statistics';
import Testimonials from './Testimonials';
import FactoringBanner from './FactoringBanner';
import HelpFAQ from '../faq/HelpFAQ';
import useGetCountry from '../../helpers/useGetCountry';
import CountryEnum from '../../constants/country-enum';
import { isMexicoEnabled, useIsMexicoDisabled } from '../../helpers/featureFlags';

function Home() {
  const country = useGetCountry();
  const isMexicoDisabled = useIsMexicoDisabled();
  const showFingoSteps = !isMexicoDisabled;
  return (
    <Grid>
      <Hero />
      <Statistics />
      <OurSolutions />
      {showFingoSteps ? <FingoSteps /> : <FactoringBanner />}
      <Testimonials />
      {country === CountryEnum.MEXICO && isMexicoEnabled && <HelpFAQ />}
      {showFingoSteps && <FactoringBanner />}
    </Grid>
  );
}

export default Home;
